<template>
    <div v-show="visible" class="org-window org-window-cdn">
        <div
            id="contactsWindowWaterMark"
            ref="waterMarkBox"
            class="org-window-main-box"
        >
            <div
                v-if="userLevel >= -1 && defaultState === 'normal'"
                class="org-window-main"
            >
                <header class="org-window-header">
                    {{ title }}
                </header>
                <div class="org-window-content">
                    <div class="org-window-content-left">
                        <div class="search-area">
                            <Search
                                ref="search"
                                :selected="selected"
                                :count-limit="countLimit"
                                :is-staff="isStaff"
                                :login-rights="loginRights"
                                :default-selected="defaultSelected"
                                :can-not-selected="canNotSelected"
                                :selected-half-groups="selectedHalfGroups"
                                :selected-groups="selectedGroups"
                                :group-select-type="groupSelectType"
                                @added="added"
                                @addedGroup="addedGroup"
                                @saveGroupsList="saveGroupsList"
                                @removed="removed"
                                @removedGroup="removedGroup"
                                @maxCountLimit="maxCountLimit"
                            />
                        </div>
                        <div v-if="tabs && tabs.length !== 0" class="tab-box">
                            <ul class="tab">
                                <li
                                    v-if="showTab('recentChat')"
                                    class="tab-item"
                                    :class="{
                                        active: currentView === 'recentChat'
                                    }"
                                    @click="changeTab('recentChat')"
                                >
                                    <span>最近聊天</span>
                                </li>
                                <li
                                    v-if="showTab('myDept')"
                                    class="tab-item"
                                    :class="{
                                        active: currentView === 'myDept'
                                    }"
                                    @click="changeTab('myDept')"
                                >
                                    <span
                                        v-html="
                                            isStaff ? '我的部门' : '对接部门'
                                        "
                                    />
                                </li>
                                <li
                                    v-if="showTab('myProject')"
                                    class="tab-item"
                                    :class="{
                                        active: currentView === 'myProject'
                                    }"
                                    @click="changeTab('myProject')"
                                >
                                    <span>我的团队</span>
                                </li>
                                <li
                                    v-if="showTab('contacts')"
                                    class="tab-item contacts"
                                    :class="{
                                        active: currentView === 'contacts'
                                    }"
                                    @click="changeTab('contacts')"
                                >
                                    <span>常用联系人/群</span>
                                </li>
                            </ul>
                        </div>
                        <div v-if="tabs && tabs.length !== 0" class="main-box">
                            <keep-alive>
                                <RecentChat
                                    v-if="currentView === 'recentChat'"
                                    ref="recentchat"
                                    :selected="selected"
                                    :count-limit="countLimit"
                                    :is-staff="isStaff"
                                    :login-rights="loginRights"
                                    :default-selected="defaultSelected"
                                    :can-not-selected="canNotSelected"
                                    :selected-groups="selectedGroups"
                                    :selected-half-groups="selectedHalfGroups"
                                    :group-select-type="groupSelectType"
                                    :conversation-type="conversationType"
                                    @added="added"
                                    @addedGroup="addedGroup"
                                    @saveGroupsList="saveGroupsList"
                                    @checkedHalf="checkedHalf"
                                    @removed="removed"
                                    @removedGroup="removedGroup"
                                    @maxCountLimit="maxCountLimit"
                                />
                            </keep-alive>
                            <!--myDept需要联动，所以使用v-show，但是如果没有这个tab的时候，直接v-if隐藏就行-->
                            <MyDept
                                v-if="tabs.indexOf('myDept') > -1"
                                v-show="currentView === 'myDept'"
                                ref="mydept"
                                :selected="selected"
                                :count-limit="countLimit"
                                :is-staff="isStaff"
                                :login-rights="loginRights"
                                :default-selected="defaultSelected"
                                :can-not-selected="canNotSelected"
                                @added="added"
                                @removed="removed"
                                @maxCountLimit="maxCountLimit"
                            />
                            <keep-alive>
                                <MyProject
                                    v-if="currentView === 'myProject'"
                                    ref="myproject"
                                    :selected="selected"
                                    :count-limit="countLimit"
                                    :is-staff="isStaff"
                                    :login-rights="loginRights"
                                    :default-selected="defaultSelected"
                                    :can-not-selected="canNotSelected"
                                    :project-id="projectId"
                                    @added="added"
                                    @removed="removed"
                                    @maxCountLimit="maxCountLimit"
                                />
                            </keep-alive>
                            <keep-alive>
                                <Contacts
                                    v-if="currentView === 'contacts'"
                                    ref="contacts"
                                    :selected="selected"
                                    :count-limit="countLimit"
                                    :is-staff="isStaff"
                                    :login-rights="loginRights"
                                    :default-selected="defaultSelected"
                                    :can-not-selected="canNotSelected"
                                    :selected-groups="selectedGroups"
                                    :selected-half-groups="selectedHalfGroups"
                                    :group-select-type="groupSelectType"
                                    @added="added"
                                    @addedGroup="addedGroup"
                                    @saveGroupsList="saveGroupsList"
                                    @checkedHalf="checkedHalf"
                                    @removed="removed"
                                    @removedGroup="removedGroup"
                                    @maxCountLimit="maxCountLimit"
                                />
                            </keep-alive>
                        </div>
                    </div>
                    <div class="org-window-content-right">
                        <p class="number-selected">
                            已选：{{ selectedLen }}
                            {{ groupSelectType === 0 ? '人' : '个' }}
                        </p>
                        <div ref="scrollBox" class="selected-box">
                            <!--kepps-->
                            <ul class="memberList">
                                <li
                                    v-for="selectedItem in pageList"
                                    :key="selectedItem.id"
                                    class="member"
                                >
                                    <Avatar
                                        v-if="!isGroup(selectedItem)"
                                        class="avatar"
                                        :user="selectedItem"
                                    />
                                    <GroupAvatar
                                        v-else
                                        :group="selectedItem"
                                        class="avatar"
                                    />
                                    <div
                                        v-if="!isGroup(selectedItem)"
                                        class="detail"
                                    >
                                        <p class="name">
                                            <span class="name-flex">{{
                                                selectedItem.name
                                            }}</span>
                                            <span
                                                class="account"
                                            >({{
                                                selectedItem.lxAccount
                                            }})</span>
                                        </p>
                                        <p class="position">
                                            {{
                                                selectedItem.tag1 ||
                                                    selectedItem.job
                                            }}
                                        </p>
                                    </div>
                                    <div v-else class="detail">
                                        <p class="name">
                                            {{ selectedItem.name }} ({{
                                                selectedItem.memberCount
                                            }})
                                        </p>
                                    </div>
                                    <i
                                        v-if="!isDefault(selectedItem)"
                                        class="deleteIcon"
                                        @click="removed([selectedItem])"
                                    />
                                </li>
                            </ul>
                        </div>
                        <div v-if="hasExtra" class="extra-box">
                            <input
                                v-model="extraText"
                                type="text"
                                :placeholder="extraPlaceholder"
                                class="extra"
                                :class="{ focus: extraFocus }"
                                @focus="extraFocus = true"
                                @blur="extraFocus = false"
                                @input="checkExtraLength"
                            >
                            <i
                                v-show="extraText.length > 0"
                                class="clearExtra"
                                @click="extraText = ''"
                            />
                        </div>
                        <div class="btn-box">
                            <button
                                type="button"
                                class="cancel"
                                @click="doCancelCallback"
                            >
                                取消
                            </button>
                            <button
                                type="button"
                                class="confirm"
                                :disabled="
                                    selected.length <= defaultSelected.length
                                "
                                @click="doCallback"
                            >
                                完成
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div
                v-if="userLevel < -1 && defaultState === 'normal'"
                class="org-status"
            >
                <img
                    src="@/assets/images/contacts/close-grey.png"
                    alt=""
                    class="close-icon"
                    @click="doCancelCallback"
                >
                <img
                    src="@/assets/images/contacts/user-noAuthority.png"
                    alt=""
                    class="status-img"
                >
                <p class="status-text">
                    暂无权限
                </p>
            </div>
            <div v-else class="org-window-main">
                <div v-if="defaultState === 'loading'" class="org-status">
                    <img
                        src="@/assets/images/contacts/close-grey.png"
                        alt=""
                        class="close-icon"
                        @click="doCancelCallback"
                    >
                    <img
                        src="https://s1.longfor.com/image/40348b3e1ff6aa6833902accafcc0c4f.gif"
                        alt=""
                        class="status-img"
                    >
                    <p class="status-text">
                        加载中
                    </p>
                </div>
                <div
                    v-if="defaultState === 'dataLoadingFailed'"
                    class="org-status"
                >
                    <img
                        src="@/assets/images/contacts/close-grey.png"
                        alt=""
                        class="close-icon"
                        @click="doCancelCallback"
                    >
                    <img
                        src="@/assets/images/contacts/data_loading_failed.png"
                        alt=""
                        class="status-img"
                    >
                    <p class="status-text">
                        数据加载失败，请重试
                    </p>
                    <div class="status-reload">
                        <button
                            type="button"
                            class="reload"
                            @click="reload(optionsData, callback)"
                        >
                            重新加载
                        </button>
                    </div>
                </div>
                <div
                    v-if="defaultState === 'serviceAbnormal'"
                    class="org-status"
                >
                    <img
                        src="@/assets/images/contacts/close-grey.png"
                        alt=""
                        class="close-icon"
                        @click="doCancelCallback"
                    >
                    <img
                        src="@/assets/images/contacts/service_abnormal.png"
                        alt=""
                        class="status-img"
                    >
                    <p class="status-text">
                        服务异常，请联系IT报事
                    </p>
                    <div class="status-reload">
                        <button
                            type="button"
                            class="reload"
                            @click="reload(optionsData, callback)"
                        >
                            重新加载
                        </button>
                    </div>
                </div>
                <div
                    v-if="defaultState === 'networkAbnormal'"
                    class="org-status"
                >
                    <img
                        src="@/assets/images/contacts/close-grey.png"
                        alt=""
                        class="close-icon"
                        @click="doCancelCallback"
                    >
                    <img
                        src="@/assets/images/contacts/network_abnormal.png"
                        alt=""
                        class="status-img"
                    >
                    <p class="status-text">
                        当前网络不可用，请检查网络设置
                    </p>
                    <div class="status-reload">
                        <button
                            type="button"
                            class="reload"
                            @click="reload(optionsData, callback)"
                        >
                            重新加载
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import RecentChat from './components/RecentChat'
import MyDept from './components/MyDept'
import MyProject from './components/MyProject'
import Contacts from './components/Contacts'
import Avatar from '@/components/Avatar'
import GroupAvatar from '@/components/GroupAvatar'
import Search from './components/Search'
import {
    batchUsers,
    batchUsersByAccounts,
    getRightsByToken,
    getJumpUrl
} from '@/apis/contactsWindow/contactsWindow'
import watermark from '@/utils/contacts/watermark.js'
import contactsConfig from '@/utils/contacts/config'
import { configer } from '@/config'

export default {
    name: 'ContactsWindow',
    components: {
        RecentChat,
        MyDept,
        MyProject,
        Contacts,
        Avatar,
        GroupAvatar,
        Search
    },
    props: {},
    data() {
        return {
            optionsData: {}, // 存一下传进来的options，以便重新加载用
            currentView: 'recentChat',
            selected: [],
            searchFocus: false,
            selectedGroups: [],
            selectedHalfGroups: [],
            visible: false,
            groupSelectType: 0, // 群组选择模式; 0选人，1表示仅选群会话
            title: '',
            countLimit: 500, // 人数限制
            tabs: ['recentChat', 'myDept', 'myProject', 'contacts'], // tab限制
            hasExtra: '',
            extraPlaceholder: '',
            extraMaxLength: '',
            extraMinLength: '',
            extraText: '',
            extraFocus: false,
            idType: 0,
            conversationType: 100,
            defaultSelected: [],
            canNotSelected: [],
            projectId: '',
            callback: '',
            loginRights: {},
            defaultState: '',
            selectedGroupsList: [],
            currentPage: 1,
            pageNum: 30
        }
    },
    computed: {
        selectedLen() {
            const context = this
            return context.selected.length
        },
        canNotSelectedIds() {
            return this.canNotSelected || []
        },
        isStaff() {
            return this.loginRights.userType === 1
        },
        // 是否有通讯录权限:-1无权限;0低权限;1高权限
        userLevel() {
            return !this.loginRights.authorityGrade
                ? -2
                : +this.loginRights.authorityGrade
        },
        pageList() {
            const end = this.currentPage * this.pageNum
            return this.selected.slice(0, end)
        }
    },
    watch: {
        selected() {
            this.checkedHalf() // 更新群的选中状态
        }
    },
    methods: {
        loadMore() {
            const context = this
            const pageSize = Math.ceil(context.selected.length / context.pageNum)
            if (context.currentPage >= pageSize) {
                return
            }
            const el = context.$refs.scrollBox
            let locked = true // 防止重复调用
            const fill = 1
            const bottom = el.scrollTop + el.clientHeight + fill >= el.scrollHeight
            if (bottom && locked) {
                context.currentPage += 1
                locked = false
                setTimeout(() => {
                    locked = true
                }, 500)
            }
        },
        reload(options, callback) {
            this.defaultState = 'loading'
            this.open(options, callback)
        },
        open(options, callback) {
            // 下游如果传了token，带到请求头里
            if (options.token) {
                window.contactsToken = options.token
            } else if (window.contactsToken) {
                window.contactsToken = ''
            }
            this.defaultState = ''
            this.currentPage = 1
            document.body.appendChild(window.contactsWindowEl)
            // contactsZhugeTrack('clickContactsSelectionSdkInvoke', {
            //     SOURCE: options.systemSource
            // })
            this.optionsData = options // 重新加载需要
            this.callback = callback // 如果是bridge过来的，是个字符串，方法名；正常调用应该是传一个function；
            if (
                (options.defaultSelectedList &&
                    options.defaultSelectedList.length > 5000) ||
                (options.selectedList && options.selectedList.length > 5000) ||
                (options.cannotSelectedList &&
                    options.cannotSelectedList.length > 5000)
            ) {
                this.doErrorCallback(1002, '最多可传入5000人', 'error')
                return
            }
            // if (options.systemSource) {
            getJumpUrl({ terminalType: 'WEB' })
                .then(res => {
                    if (res.code === '0') {
                        const urlData = res.data
                        for (let i = 0; i < urlData.length; i++) {
                            if (urlData[i].urlType === 6) {
                                if (+urlData[i].appKey) {
                                    // appKey 的值为 0和空 代表放过，1代表校验
                                    const systemSourceData = urlData[
                                        i
                                    ].jumpUrl.split(',')
                                    if (
                                        systemSourceData.indexOf(
                                            options.systemSource
                                        ) >= 0
                                    ) {
                                        this.initOrgWindowData(options) // 初始化选人组件数据
                                    } else {
                                        document.body.removeChild(
                                            window.contactsWindowEl
                                        )
                                        this.doErrorCallback(
                                            1003,
                                            '暂无权限',
                                            'info'
                                        )
                                    }
                                } else {
                                    this.initOrgWindowData(options) // 初始化选人组件数据
                                }
                            }
                        }
                    } else {
                        this.visible = true
                        this.defaultState = 'dataLoadingFailed'
                    }
                })
                .catch(err => {
                    this.visible = true
                    console.warn(err)
                    if (err.message === 'Network Error') {
                        this.defaultState = 'networkAbnormal' // 当前网络不可用，请检查网络设置
                    } else {
                        this.defaultState = 'serviceAbnormal' // 服务异常，请联系IT报事
                    }
                })
            // } else {
            //     this.doErrorCallback(1003, '暂无权限', 'info')
            // }
        },
        // 添加水印
        addWaterMark(res) {
            const waterOption = {
                id: '1.23452384164.123454231',
                parentId: 'contactsWindowWaterMark',
                account: res.data.lxAccount,
                left: '0',
                top: '0',
                width: '720px',
                height: '540px',
                zIndex: 10,
                el: this.$refs.waterMarkBox
            }
            if (document.getElementById(waterOption.id) === null) {
                watermark.set(waterOption)
            }
        },
        initOrgWindowData(options) {
            const context = this
            this.selected = [] // 清空已选列表的人
            this.defaultSelected = [] // 清空默认已选不可反选的人
            this.canNotSelected = [] // 清空默认可不选的人
            this.selectedGroups = [] // 清空全选的群组
            this.selectedHalfGroups = [] // 清空半选的群组
            this.selectedGroupsList = [] // 清空所有已点过的群组
            this.extraText = ''
            getRightsByToken()
                .then(res => {
                    if (res.code === '0') {
                        this.loginRights = res.data
                        this.defaultState = 'normal'
                        // 获取到用户信息后添加水印
                        this.addWaterMark(res)
                    } else {
                        this.defaultState = 'dataLoadingFailed'
                    }
                    this.openUp(options)
                })
                .catch(err => {
                    console.warn(err)
                    this.openUp(options)
                    if (err.message === 'Network Error') {
                        context.defaultState = 'networkAbnormal' // 当前网络不可用，请检查网络设置
                    } else {
                        context.defaultState = 'serviceAbnormal' // 服务异常，请联系IT报事
                    }
                })
        },
        openUp(options) {
            const context = this
            setTimeout(() => {
                if (!this.defaultState) {
                    this.defaultState = 'loading'
                }
                this.$refs.scrollBox.addEventListener('scroll', context.loadMore)
            }, contactsConfig.loadingTimeout)
            options = options || {}
            this.visible = true
            this.groupSelectType = options.groupSelectType || 0
            this.title = options.title || '选人组件'
            this.countLimit = options.countLimit || 500 // 默认500人
            // 供方和内部无权限用户只展示最近聊天
            if (this.userLevel <= -1 || !this.isStaff) {
                if (
                    !options.tabs ||
                    (options.tabs && options.tabs.indexOf('recentChat') > -1)
                ) {
                    // 没传tabs || 传了tabs并且有recentChat
                    this.tabs = ['recentChat']
                } else {
                    // 传了tabs 但是没传 recentChat，就为空
                    this.tabs = []
                }
            } else {
                this.tabs = options.tabs || [
                    'recentChat',
                    'myDept',
                    'myProject',
                    'contacts'
                ] // 默认4个tab都在
                if (this.tabs.length <= 0) {
                    this.tabs = [
                        'recentChat',
                        'myDept',
                        'myProject',
                        'contacts'
                    ]
                }
            }
            if (this.tabs && this.tabs.length > 0) {
                this.currentView = this.tabs[0]
            }
            if (this.countLimit > 5000) {
                this.countLimit = 5000 // 最多选5000人
            }
            this.hasExtra = options.hasExtra || false
            this.extraPlaceholder = options.extraPlaceholder || ''
            this.extraMaxLength = options.extraMaxLength || ''
            this.extraMinLength = options.extraMinLength || ''
            this.projectId = options.projectId || ''
            this.idType = options.idType || 0
            this.conversationType = options.conversationType || 100 // 聊天会话类型("1":单聊；”3“：群聊；"100":单聊和群聊混合)
            if (this.idType) {
                this.getbatchUsers(options)
            } else {
                this.getbatchUsersByAccounts(options)
            }
        },
        // 批量获取人员信息根据uid
        getbatchUsers(options) {
            const context = this
            context.canNotSelected = options.cannotSelectedList || []
            const defaultSelected = options.defaultSelectedList || []
            const selectedList = options.selectedList || []
            const idList = defaultSelected.concat(selectedList)
            batchUsers(idList, (error, staffs) => {
                // 获取默认选中人的详细信息
                if (error) {
                    // context.defaultState = 'serviceAbnormal' // 服务异常，请联系IT报事
                    console.warn(error)
                }
                context.selected = staffs.data // 已选列表
                if (staffs.data && staffs.data.length > 0) {
                    staffs.data.forEach(item => {
                        if (defaultSelected.indexOf(item.uId) > -1) {
                            context.defaultSelected.push(item) // 已选不可反选
                        }
                    })
                }
            })
        },
        // 批量获取人员信息根据account
        getbatchUsersByAccounts(options) {
            const context = this
            const defaultSelected = options.defaultSelectedList || []
            const selectedList = options.selectedList || []
            const canNotSelected = options.cannotSelectedList || []
            const idList = defaultSelected
                .concat(selectedList)
                .concat(canNotSelected)
            batchUsersByAccounts(idList, (error, staffs) => {
                // 获取默认选中人的详细信息
                if (error) {
                    // context.defaultState = 'serviceAbnormal' // 服务异常，请联系IT报事
                    console.warn(error)
                }
                const staffsData = staffs.data
                if (staffsData && staffsData.length > 0) {
                    staffsData.forEach(item => {
                        if (defaultSelected.indexOf(item.lxAccount) > -1) {
                            context.defaultSelected.push(item) // 已选不可反选人员集合
                        } else if (
                            canNotSelected.indexOf(item.lxAccount) > -1
                        ) {
                            context.canNotSelected.push(item.uId) // 不可选id集合
                        }
                        if (context.canNotSelected.indexOf(item.uId) === -1) {
                            context.selected.push(item) // 已选列表，除了禁选的人
                        }
                    })
                }
            })
        },
        changeTab(type) {
            this.currentView = type
            // const tabs = {
            //     recentChat: '最近聊天',
            //     myDept: '我的部门',
            //     myProject: '我的团队',
            //     contacts: '常用联系人/群'
            // }
            // contactsZhugeTrack('clickContactsPersonalPageChangeTab', {
            //     tab: tabs[type],
            //     SOURCE: this.optionsData.systemSource
            //         ? this.optionsData.systemSource
            //         : ''
            // })
        },
        doCallback() {
            if (this.hasExtra && this.extraMinLength) {
                if (this.extraText.length < this.extraMinLength) {
                    this.$message({
                        message: `请输入 ${this.extraMinLength} - ${this.extraMaxLength} 个字`,
                        type: 'error',
                        duration: 3000
                    })
                    this.extraFocus = true
                    return
                }
            }
            this.visible = false
            document.body.removeChild(window.contactsWindowEl)
            // 格式化一下抛出数据
            const resultData = this.formatData(this.selected)
            const data = {
                list: resultData,
                extraInput: this.extraText,
                status: 0
            }
            return this.callback(data)
        },
        // 格式化一下抛出数据
        formatData(data) {
            const res = []
            for (let i = 0; i < data.length; i++) {
                let tempHeadUrl = '';
                if (data[i].uId && data[i].headId) {
                    const headId = +data[i].headId;
                    if (headId <= 10 && headId > 0) {
                        tempHeadUrl = configer.contactsAvatarURL + 'default/' + data[i].uId + '.jpg?headId=' + headId
                    } else if (headId > 10) {
                        tempHeadUrl = configer.contactsAvatarURL + data[i].uId + '.jpg?headId=' + headId
                    }
                } else if (data[i].portrait_url) { // 兼容群组头像
                    tempHeadUrl = data[i].portrait_url;
                    if (data[i].portrait_url.indexOf('{1}') >= 0) { // 通配符特殊处理。db和通讯录接口获取的都有通配符。im最近聊天获取的群组头像是没有的。
                        tempHeadUrl = data[i].portrait_url.replace('{1}', '/small/')
                    }
                } else if (data[i].portraitUrl) {
                    tempHeadUrl = data[i].portraitUrl;
                    if (data[i].portraitUrl.indexOf('{1}') >= 0) {
                        tempHeadUrl = data[i].portraitUrl.replace('{1}', '/small/')
                    }
                }
                let isExec = '';
                if (data[i].uId && +data[i].isExec === 0) {
                    isExec = 0
                } else if (data[i].uId && +data[i].isExec === 1) {
                    isExec = 1
                }
                const obj = {
                    type: data[i].uId ? 1 : 2, // 1 单人类型  2  群聊类型
                    userId: data[i].uId ? data[i].uId : data[i].id, //  type 为  1 单人类型 是用户id， type 为  2  群聊类型 是groupId
                    account: data[i].uId ? data[i].lxAccount : '', //  type 为  1 单人类型 是用户账号， type 为  2  群聊类型 为空
                    name: data[i].name, //  type 为  1 单人类型 是用户名称， type 为  2  群聊类型 是群名称
                    job: data[i].uId ? data[i].job : '', //  type 为  1 单人类型 职位， type 为  2  群聊类型 为空
                    headURL: tempHeadUrl, //  type 为  1 单人类型 是用户头像url， type 为  2  群聊类型 是群聊头像
                    userType: data[i].uId ? data[i].userType : '', //  type 为  1 单人类型 时使用：  1 内部员工  2 外部员工， type 为  2  群聊类型 为空
                    isExec //  type 为  1 单人类型 时使用：是否是高权限 0 不是 1 是高权限， type 为  2  群聊类型 为空
                };
                res.push(obj)
            }
            return res
        },
        // 取消
        doCancelCallback() {
            this.visible = false
            document.body.removeChild(window.contactsWindowEl)
            const data = {
                list: [],
                extraInput: '',
                status: 1001 // 用户取消
            }
            return this.callback(data)
        },
        added(members) {
            const context = this
            const selectedIdList = context.selected.map(item => item.id)
            const addedList = members.filter(
                item => selectedIdList.indexOf(item.id) < 0
            )
            context.selected = context.selected.concat(addedList)
            if (this.$refs.mydept) {
                this.$refs.mydept.addAllContactStaff(
                    members,
                    members.length > 1
                ) // 得把组件里的全选状态更新
            }
        },
        addedGroup(group) {
            const context = this
            const selectedGroupIdList = context.selectedGroups.map(
                item => item.id
            )
            const addedList = group.filter(
                item => selectedGroupIdList.indexOf(item.id) < 0
            )
            context.selectedGroups = context.selectedGroups.concat(addedList)
        },
        removed(members) {
            const context = this
            const idList = members.map(item => item.id)
            const reservedIdList = context.defaultSelected.map(item => item.id)
            context.selected = context.selected.filter(item => {
                const reserved = reservedIdList.indexOf(item.id) >= 0
                return reserved || idList.indexOf(item.id) < 0
            })
            // 取被删除的人（即排除默认选中的人）
            const deleteMemberList = members.filter(item => {
                return reservedIdList.indexOf(item.id) < 0
            })
            if (this.$refs.mydept) {
                this.$refs.mydept.removeMembers(deleteMemberList) // 得把组件里的全选状态更新
            }
            if (members.length === 1 && this.isGroup(members[0])) {
                // 删除群聊，只有在已选列表删除的场景，所以判断length===1
                this.removedGroup(members)
            }
        },
        removedGroup(members) {
            const context = this
            const idList = members.map(item => item.id)
            context.selectedGroups = context.selectedGroups.filter(item => {
                return idList.indexOf(item.id) < 0
            })
        },
        // 选中群聊时保存一下群以及群成员信息：selectedGroupsList
        saveGroupsList(group) {
            const context = this
            const selectedGroupIdList = context.selectedGroupsList.map(
                item => item.id
            )
            const addedList = group.filter(
                item => selectedGroupIdList.indexOf(item.id) < 0
            )
            context.selectedGroupsList = context.selectedGroupsList.concat(
                addedList
            )
        },
        // 新增半选群并存储群信息到selectedHalfGroups
        addedHalfGroup(group) {
            const context = this
            const selectedGroupIdList = context.selectedHalfGroups.map(
                item => item.id
            )
            const addedList = group.filter(
                item => selectedGroupIdList.indexOf(item.id) < 0
            )
            context.selectedHalfGroups = context.selectedHalfGroups.concat(
                addedList
            )
        },
        // 移除半选群更新selectedHalfGroups
        removedHalfGroup(group) {
            const context = this
            const idList = group.map(item => item.id)
            context.selectedHalfGroups = context.selectedHalfGroups.filter(
                item => {
                    return idList.indexOf(item.id) < 0
                }
            )
        },
        // 更新群状态：全选、半选、未选
        checkedHalf() {
            const context = this
            // 判断已选中的群的长度，有则往下走选中逻辑
            if (context.selectedGroupsList.length > 0) {
                const selectedIdList = context.selected.map(
                    selectedItem => selectedItem.id
                )
                context.selectedGroupsList.forEach(item => {
                    const intersections = item.memberList.filter(val => {
                        // 取交集
                        return selectedIdList.indexOf(val) > -1
                    })
                    if (intersections.length === 0) {
                        this.removedHalfGroup([item])
                        this.removedGroup([item])
                    } else if (item.memberList.length > intersections.length) {
                        this.addedHalfGroup([item])
                        this.removedGroup([item])
                    } else if (
                        item.memberList.length === intersections.length
                    ) {
                        this.addedGroup([item])
                        this.removedHalfGroup([item])
                    }
                })
            }
        },
        maxCountLimit() {
            const count = this.countLimit
            this.$message({
                message: `最多可选择 ${count} ${
                    this.groupSelectType === 0 ? '人' : '个'
                }`,
                type: 'error',
                duration: 3000
            })
            this.reset()
        },
        reset() {
            this.selected.push({})
            this.selected.pop()
        },
        checkExtraLength() {
            if (this.hasExtra && this.extraMaxLength) {
                if (this.extraText.length > this.extraMaxLength) {
                    this.extraText = this.extraText.substr(
                        0,
                        this.extraMaxLength
                    )
                }
            }
        },
        showTab(tabName) {
            return this.tabs.indexOf(tabName) > -1
        },
        isGroup(item) {
            return !item.uId // group没有uId
        },
        doErrorCallback(statusCode, log, type) {
            this.$message({
                message: log,
                type: type,
                duration: 3000
            })
            const data = {
                list: [],
                extraInput: '',
                status: statusCode
            }
            return this.callback(data)
        },
        /* 成员的禁用状态，是否可选择、取消。 1.默认选中成员 */
        isDisabled(item) {
            return (
                this.isDefault(item) ||
                this.isDelete(item) ||
                this.executiveLimit(item) ||
                this.isCannotSelected(item)
            )
        },
        // 是否默认已选人员
        isDefault(item) {
            const idList = this.defaultSelected.map(temp => temp.id)
            return idList.indexOf(item.id) >= 0
        },
        isDelete(item) {
            const isDelete = item && (+item.status === 0 || +item.status === 2) // status是0或2的人不能被选中 0离职2禁用
            return isDelete
        },
        executiveLimit(item) {
            if (this.isStaff && this.userLevel >= 1) {
                return false
            }
            const isExec = item && !!+item.isExec
            return isExec
        },
        // 是否默认不可选人员
        isCannotSelected(item) {
            return this.canNotSelectedIds.indexOf(item.id) >= 0
        }
    }
}
</script>

<style lang="scss" scoped>
input::-ms-clear,
::-ms-reveal {
    display: none;
} // 去除ie input右侧默认的×
.org-window {
    width: 100%;
    height: 100%;
    position: fixed;
    left: 0;
    top: 0;
    z-index: 8000;
    user-select: none;
    .org-window-main-box {
        width: 720px;
        height: 540px;
        margin: auto;
        position: fixed;
        left: 50%;
        top: 50%;
        transform: translateX(-50%) translateY(-50%);
        background-color: #fff;
        border: 1px solid #eaeaea;
        box-sizing: border-box;
        box-shadow: 0 8px 36px rgba(0, 0, 0, 0.18);
        border-radius: 6px;
    }
    .org-window-main {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        .org-window-header {
            height: 48px;
            padding: 12px;
            box-sizing: border-box;
            font-weight: 600;
            font-size: 16px;
            line-height: 24px;
            color: #323232;
            box-shadow: inset 0px -1px 0px #f5f5f5;
        }
        .org-window-content {
            flex: 1;
            overflow: hidden;
            display: flex;
            .org-window-content-left {
                width: 360px;
                box-shadow: inset -1px 0px 0px #f5f5f5;
                display: flex;
                flex-direction: column;
                .search-area {
                    height: 54px;
                    padding: 12px;
                    box-sizing: border-box;
                }
                .tab-box {
                    height: 54px;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    .tab {
                        width: 336px;
                        height: 30px;
                        border: 1px solid #eaeaea;
                        box-sizing: border-box;
                        border-radius: 2px;
                        display: flex;
                        .tab-item {
                            border-right: 1px solid #eaeaea;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            color: #6f6f6f;
                            cursor: pointer;
                            flex-grow: 1; // 兼容ie11用flex-grow(原：flex: 1)
                            &.contacts {
                                min-width: 103px;
                            }
                            span {
                                font-size: 12px;
                            }
                            &:hover {
                                color: #007af5;
                            }
                            &.active {
                                background: #007af5;
                                color: #fff;
                                font-weight: 600;
                            }
                        }
                        .tab-item:first-child {
                            border-radius: 2px 0 0 2px;
                        }
                        .tab-item:last-child {
                            border-radius: 0 2px 2px 0;
                            border-right: 0;
                        }
                    }
                }
                .main-box {
                    flex: 1;
                    overflow: hidden;
                }
            }
            .org-window-content-right {
                flex: 1;
                display: flex;
                flex-direction: column;
                overflow: hidden;
                .number-selected {
                    height: 54px;
                    line-height: 54px;
                    font-size: 14px;
                    color: #323232;
                    text-indent: 12px;
                }
                .selected-box {
                    flex: 1;
                    overflow-y: auto;
                    .memberList {
                        .member {
                            display: flex;
                            align-items: center;
                            padding: 7px 18px;
                            &:hover {
                                background-color: #f5f5f5;
                            }
                            .avatar {
                                width: 36px;
                                height: 36px;
                                margin: 0 12px;
                            }
                            .detail {
                                flex: 1;
                                overflow: hidden;
                                .name {
                                    font-size: 14px;
                                    line-height: 22px;
                                    color: #323232;
                                    overflow: hidden;
                                    display: flex;
                                    .name-flex {
                                        white-space: nowrap;
                                        text-overflow: ellipsis;
                                        overflow: hidden;
                                        max-width: 115px;
                                        padding-right: 6px;
                                    }
                                    .account {
                                        flex: 1;
                                        white-space: nowrap;
                                        text-overflow: ellipsis;
                                        overflow: hidden;
                                        color: #999999;
                                    }
                                }
                                .position {
                                    font-size: 12px;
                                    line-height: 18px;
                                    color: #999999;
                                    white-space: nowrap;
                                    text-overflow: ellipsis;
                                    overflow: hidden;
                                }
                            }
                            .deleteIcon {
                                width: 18px;
                                height: 18px;
                                background: url('../../assets/images/contacts/org-window-del.png');
                                background-size: 100% 100%;
                                cursor: pointer;
                                &:hover {
                                    background: url('../../assets/images/contacts/org-window-del-hover.png');
                                    background-size: 100% 100%;
                                }
                            }
                        }
                    }
                }
                .extra-box {
                    height: 42px;
                    display: flex;
                    flex-direction: column;
                    justify-content: flex-end;
                    align-items: center;
                    position: relative;
                    background: rgba(255, 255, 255, 1);
                    .extra {
                        border: 1px solid #eaeaea;
                        box-sizing: border-box;
                        border-radius: 2px;
                        width: 334px;
                        height: 30px;
                        font-size: 14px;
                        color: #323232;
                        text-indent: 12px;
                        padding-right: 34px;
                        &.focus {
                            border: 1px solid #007af5;
                        }
                    }
                    input::-webkit-input-placeholder {
                        color: #c1c1c1;
                    }
                    .clearExtra {
                        position: absolute;
                        right: 22px;
                        top: 18px;
                        width: 18px;
                        height: 18px;
                        background: url('../../assets/images/contacts/org-window-delete.png');
                        background-size: 100% 100%;
                        cursor: pointer;
                        &:hover {
                            background: url('../../assets/images/contacts/org-window-delete-hover.png');
                            background-size: 100% 100%;
                        }
                    }
                }
                .btn-box {
                    height: 60px;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    padding: 0 12px;
                    background: rgba(255, 255, 255, 1);
                    .cancel {
                        width: 88px;
                        height: 36px;
                        border: 0;
                        box-sizing: border-box;
                        border-radius: 2px;
                        font-size: 14px;
                        color: #323232;
                        cursor: pointer;
                        background-color: #f4f5f6;
                        &:hover {
                            background-color: #eef0f2;
                        }
                    }
                    .confirm {
                        width: 235.5px;
                        height: 36px;
                        background: #007af5;
                        border-radius: 2px;
                        font-weight: 600;
                        font-size: 14px;
                        color: #ffffff;
                        cursor: pointer;
                        border: none;
                        &:hover {
                            background-color: #006edd;
                        }
                        &[disabled] {
                            background: #eaeaea;
                            color: #c1c1c1;
                            cursor: not-allowed;
                        }
                    }
                }
            }
        }
    }
    .org-status {
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        position: relative;
        .close-icon {
            position: absolute;
            right: 18px;
            top: 18px;
            width: 24px;
            height: 24px;
            cursor: pointer;
        }
        .status-img {
            width: 90px;
            height: 90px;
        }
        .status-text {
            font-size: 14px;
            line-height: 22px;
            color: #464646;
            margin: 12px 0;
        }
        .status-reload {
            width: 180px;
            height: 36px;
            margin-top: 18px;
            .reload {
                width: 100%;
                height: 36px;
                font-size: 14px;
                color: #fff;
                text-align: center;
                line-height: 36px;
                border: 0;
                background: #007af5;
                border-radius: 2px;
                cursor: pointer;
                &:hover {
                    background-color: #006edd;
                }
            }
        }
    }
}
</style>
